// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Eye as RawEye } from "lucide-react";
export const Eye = /* @__PURE__ */ createIcon(RawEye, "Eye", 2);
